var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78066 5.80332C3.78066 4.47793 4.85703 3.40098 6.18242 3.40098C7.51016 3.40098 8.58418 4.47793 8.58418 5.80332C8.58418 7.12871 7.51016 8.20566 6.18242 8.20566C4.85703 8.20566 3.78066 7.12871 3.78066 5.80332ZM10.1557 3.68691C9.27793 2.30176 7.94082 1.59863 6.18242 1.59863C4.42695 1.59863 3.08984 2.30176 2.20918 3.68691C1.52715 4.7627 1.37598 5.86895 1.37598 5.88066L0.183594 5.72949C0.189453 5.67324 0.358789 4.38301 1.1709 3.08457C1.93672 1.85996 3.42793 0.397461 6.18242 0.397461C8.94043 0.397461 10.4316 1.85996 11.1963 3.08457C12.009 4.38301 12.1777 5.67324 12.1836 5.72949L11.5877 5.80332L10.9918 5.88066C10.9918 5.86895 10.8406 4.7627 10.1557 3.68691Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewEyeIcon);
export default __webpack_public_path__ + "static/media/preview-eye-icon.05aefadb0691e3352c2a018e5e8ff5ff.svg";
export { ForwardRef as ReactComponent };